import { EMPTY_OBJECT } from '../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'
import { getSelectDropdownListDividerOption } from '../../Select'

import {
  ENTITY_TAB_EMAILS_ACTION,
  ENTITY_TAB_EMAILS_ACTION_LABEL_KEY,
  ENTITY_TAB_EMAILS_MESSAGE_QUERY_PARAM_KEY,
} from './EntityTabEmails.constants'

// Deep-links to the copy's pop-up on the current profile tab, preserving any
// existing query (pagination, etc.) and overriding only the message param.
export function getEntityTabEmailsMessageDeepLink({ pathname, search, uuid }) {
  const searchParams = new URLSearchParams(search)

  searchParams.set(ENTITY_TAB_EMAILS_MESSAGE_QUERY_PARAM_KEY, uuid)

  return `${pathname}?${searchParams.toString()}`
}

export function getEntityTabEmailsItemActions({ permissions = EMPTY_OBJECT }) {
  const items = [
    {
      label:
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[
          ENTITY_TAB_EMAILS_ACTION.OpenInNewTab
        ],
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.OpenInNewTab,
    },
    {
      label:
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[
          ENTITY_TAB_EMAILS_ACTION.ViewOriginalEmail
        ],
      permission: permissions.can_view_original_email,
      value: ENTITY_TAB_EMAILS_ACTION.ViewOriginalEmail,
    },
    {
      label:
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[ENTITY_TAB_EMAILS_ACTION.AddNote],
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.AddNote,
    },
    null,
    {
      label:
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[ENTITY_TAB_EMAILS_ACTION.DeleteCopy],
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.DeleteCopy,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getEntityTabEmailsMessageModalActions({ item, t }) {
  const { permissions = EMPTY_OBJECT } = item || EMPTY_OBJECT

  const items = [
    {
      label: t(
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[
          ENTITY_TAB_EMAILS_ACTION.OpenInNewTab
        ]
      ),
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.OpenInNewTab,
    },
    {
      label: t(
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[
          ENTITY_TAB_EMAILS_ACTION.ViewOriginalEmail
        ]
      ),
      permission: permissions.can_view_original_email,
      value: ENTITY_TAB_EMAILS_ACTION.ViewOriginalEmail,
    },
    {
      label: t(
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[ENTITY_TAB_EMAILS_ACTION.AddNote]
      ),
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.AddNote,
    },
    getSelectDropdownListDividerOption(),
    {
      label: t(
        ENTITY_TAB_EMAILS_ACTION_LABEL_KEY[ENTITY_TAB_EMAILS_ACTION.DeleteCopy]
      ),
      permission: true,
      value: ENTITY_TAB_EMAILS_ACTION.DeleteCopy,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
